import React, { useState, useEffect } from 'react'
import './App.css'
import './Profile.css'
import './Marketing.css'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import { IoPeopleOutline, IoCloudUploadOutline } from 'react-icons/io5'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import Header from './layouts/Header'
import SideNav from './layouts/SideNav'
import { BiMenu } from 'react-icons/bi'
import { API_URL } from './config'

const Sms = () => {
  const history = useHistory()
  const [audience, setAudience] = useState(0)
  const [selected, setSelected] = useState(null) // 'EXISTING' | 'NEW' | null

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState(isMobile)
  const [collapsed, setCollapsed] = useState(isMobile)

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    const businessid = localStorage.getItem('businessid')

    document.title = 'Marketing campaign'
    axios
      .get(
        `${API_URL}/apps/kscanner/webservices.php?query=NUMBEROFCLIENTELE&businessid=${businessid}`,
        { withCredentials: true },
      )
      .then((response) => {
        setAudience(response.data.val == 1 ? response.data.clientCount : 0)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [])

  function existingAudience() {
    setSelected((prev) => (prev === 'EXISTING' ? null : 'EXISTING'))
    localStorage.setItem('audience', audience)
  }

  function newAudience() {
    setSelected((prev) => (prev === 'NEW' ? null : 'NEW'))
  }

  function next() {
    const alias = selected === 'EXISTING' ? 'EXISTINGAUDIENCE' : 'NEWAUDIENCE'

    history.push({
      pathname: alias === 'NEWAUDIENCE' ? 'uploaddata' : 'marketing',
    })

    localStorage.setItem('alias', alias)
    localStorage.setItem('type', 'SMS')
  }

  if (localStorage.getItem('businessname') === null) {
    return <Redirect to="/login" />
  }

  const handleToggle = () => setCollapsed((prev) => !prev)

  return (
    <div className="view">
      <Header />
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

      {isMob && collapsed && (
        <label className="mobile-toggle" onClick={handleToggle}>
          <BiMenu size={25} />
        </label>
      )}

      <main
        className="pf-page"
        style={{
          marginTop: 'var(--header-h)',
          marginLeft: isMob ? 0 : collapsed ? '76px' : '252px',
        }}
      >
        <div className="pf-container">
          <div className="pf-top">
            <button type="button" className="pf-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <button type="button" className="pf-edit mk-send" onClick={next} disabled={!selected}>
              Next
            </button>
          </div>

          <section className="pf-card">
            <div className="pf-card__head">
              <h2>
                <IoPeopleOutline size={18} />
                Send to...
              </h2>
            </div>

            <div className="mk-body">
              <div className="mk-options mk-options--stack">
                <button
                  type="button"
                  className={`mk-option ${selected === 'EXISTING' ? 'mk-option--active' : ''}`}
                  onClick={existingAudience}
                >
                  <IoPeopleOutline size={20} />
                  <span>Your existing audience</span>
                  <span className="mk-option__count">{audience}</span>
                </button>

                <button
                  type="button"
                  className={`mk-option ${selected === 'NEW' ? 'mk-option--active' : ''}`}
                  onClick={newAudience}
                >
                  <IoCloudUploadOutline size={20} />
                  <span>Upload your own audience</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}

export default Sms
